export default __webpack_public_path__ + "static/media/Icons_Share.1725ad43.svg";